<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Reviews</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Reviews</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'ReviewList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  
                  <li><strong>ID</strong> {{ value.id }}</li>
                  
                  <li><strong>Star Rating</strong> {{ value.star_rating }}</li>
                  
                  <li><strong>Class Rating</strong> {{ value.class_rating }}</li>
                  
                  <li><strong>Recommend</strong> {{ value.recommend }}</li>
                  
                  <li><strong>Title</strong> {{ value.title }}</li>
                  
                  <li><strong>Body</strong> {{ value.body }}</li>
                  
                  <li><strong>Reply</strong> {{ value.reply }}</li>
                  
                  <li><strong>Approve star rating</strong> {{ value.approved_star_rating }}</li>
                  
                  <li><strong>Approved Class Rating</strong> {{ value.approved_class_rating }}</li>
                  
                  <li><strong>Reviewable Type</strong> {{ value.reviewable_type }}</li>
                  
                  <li><strong>Reviewable Id</strong> 
                      <span v-if="!_.isNil(value.reviewable_id)">{{ pre.reviewable_id[value.reviewable_id] }}</span>
                    </li>
                  
                  <li><strong>author_type</strong> {{ value.author_type }}</li>
                  
                  <li><strong>Author Id</strong> {{ value.author_id }}</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "ReviewShow",
  metaInfo: {
    title: "Reviews | Dotlines"
  },
  data: () => ({
    value: {
      
    },
    pre: {
      reviewable_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    reviewableIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/8")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.reviewableIdOptions().then(reviewable_id => {
        this.pre.reviewable_id = reviewable_id;
      });
      

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/reviews/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
        